import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './verification-gate.scss.js';

class VerificationGate extends s {
    constructor() {
        super(...arguments);
        this.mainTitle = '';
        this.subtitle = '';
        this.moreInfoText = '';
        this.moreInfoContent = '';
        this.accessInstructionText = '';
        this.loginButtonText = '';
        this.createAccountButtonText = '';
        this.notProfessionalText = '';
        this.homepageLinkText = '';
        this.homepageUrl = '';
        this.moreInfoUrl = '';
        this.showMoreInfoButton = true;
        this.moreInfoExpanded = false;
    }
    toggleMoreInfo(e) {
        e.preventDefault();
        this.moreInfoExpanded = !this.moreInfoExpanded;
    }
    handleKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.moreInfoExpanded = !this.moreInfoExpanded;
        }
    }
    renderMoreInfoContent() {
        return x `<div class="more-info-content" id="more-info-content"><p>${this.moreInfoContent}</p></div>`;
    }
    renderMoreInfo() {
        if (!this.showMoreInfoButton) {
            return '';
        }
        const toggleIcon = this.moreInfoExpanded ? '-' : '+';
        const ariaExpanded = this.moreInfoExpanded ? 'true' : 'false';
        return x `<div class="more-info-container"><div @click="${this.toggleMoreInfo}" @keydown="${this.handleKeyDown}" class="more-info-header" tabindex="0" role="button" aria-expanded="${ariaExpanded}" aria-controls="more-info-content"><span class="more-info-text">${this.moreInfoText}</span> <span class="toggle-icon">${toggleIcon}</span></div>${this.moreInfoExpanded ? this.renderMoreInfoContent() : ''}</div>`;
    }
    render() {
        return x `<div class="verification-gate"><div class="verification-content"><h1 class="main-title" aria-label="${this.mainTitle}">${this.mainTitle}</h1><p class="subtitle">${this.subtitle}</p>${this.renderMoreInfo()}<p class="access-instruction">${this.accessInstructionText}</p><button class="login-button" aria-label="${this.loginButtonText}">${this.loginButtonText}</button> <button class="create-account-button" aria-label="${this.createAccountButtonText}">${this.createAccountButtonText}</button><div class="footer"><span class="not-professional">${this.notProfessionalText}</span> <a href="${this.homepageUrl}" class="homepage-link" aria-label="${this.homepageLinkText}">${this.homepageLinkText} </a><span class="additional-text">to get more information.</span></div></div></div>`;
    }
}
VerificationGate.styles = css_248z;
__decorate([
    n({ type: String })
], VerificationGate.prototype, "mainTitle", void 0);
__decorate([
    n({ type: String })
], VerificationGate.prototype, "subtitle", void 0);
__decorate([
    n({ type: String })
], VerificationGate.prototype, "moreInfoText", void 0);
__decorate([
    n({ type: String })
], VerificationGate.prototype, "moreInfoContent", void 0);
__decorate([
    n({ type: String })
], VerificationGate.prototype, "accessInstructionText", void 0);
__decorate([
    n({ type: String })
], VerificationGate.prototype, "loginButtonText", void 0);
__decorate([
    n({ type: String })
], VerificationGate.prototype, "createAccountButtonText", void 0);
__decorate([
    n({ type: String })
], VerificationGate.prototype, "notProfessionalText", void 0);
__decorate([
    n({ type: String })
], VerificationGate.prototype, "homepageLinkText", void 0);
__decorate([
    n({ type: String })
], VerificationGate.prototype, "homepageUrl", void 0);
__decorate([
    n({ type: String })
], VerificationGate.prototype, "moreInfoUrl", void 0);
__decorate([
    n({ type: Boolean })
], VerificationGate.prototype, "showMoreInfoButton", void 0);
__decorate([
    t()
], VerificationGate.prototype, "moreInfoExpanded", void 0);
customElements.define('verification-gate', VerificationGate);

export { VerificationGate };
